import { useEffect } from 'react'
import { useEditor } from '@/state/store'
import { migrateProject } from '@/model/migrate'
import { decodeShareFromHash, hasShareHash } from '@/lib/share'

/**
 * On mount, if the page was opened on a `#d=` share link, decode the embedded
 * design and load it read-only (Track 7a). Runs before the normal autosave-load
 * so the user's own local project is never touched while viewing a share.
 *
 * Sync + idempotent: decoding is synchronous, so by the time `useAutosave`'s load
 * effect checks `hasShareHash()` the read-only project is already in place.
 */
export function useShareLink() {
  useEffect(() => {
    if (!hasShareHash()) return
    const raw = decodeShareFromHash()
    if (raw == null || typeof raw !== 'object') {
      // Unreadable payload — leave the default project; surface a console hint.
      console.warn('[plinth] share link could not be decoded; showing a new project')
      return
    }
    try {
      const project = migrateProject(raw)
      const s = useEditor.getState()
      s.loadProject(project)
      s.setReadOnly(true)
    } catch (err) {
      console.warn('[plinth] failed to load shared design:', err)
    }
  }, [])
}
